import { IconAdd } from '@consta/icons/IconAdd'
import cn from 'classnames'
import type { ReactNode } from 'react'

import type { Nullable } from '../../types'
import css from './List.css'
import { ListItem } from './ListItem'

const listCreateClassName = cn(css.item, css.createAction)

type HasKey = { key: string | number }

type ListProps<T extends HasKey> = {
  className?: string
  items: T[]
  selectedItem: Nullable<T['key']>
  createLabel?: string
  onSelect?: (item: T) => void
  createAction?: VoidFunction
  children: (item: T, index: number, array: T[]) => ReactNode
}

export const List = <T extends HasKey>({
  className,
  items,
  selectedItem,
  createLabel = 'Новый объект',
  onSelect,
  createAction,
  children,
}: ListProps<T>) => {
  return (
    <ul className={cn(css.container, className)}>
      {!!createAction && (
        <li className={listCreateClassName} onClick={createAction}>
          <ListItem.Icon icon={IconAdd} view="brand" size="s" />
          <ListItem.Name>{createLabel}</ListItem.Name>
        </li>
      )}
      {items.map((item, index, array) => (
        <li
          key={item.key}
          className={css.itemWrapper}
          aria-selected={item.key === selectedItem}
          onClick={() => {
            onSelect?.(item)
          }}>
          {children(item, index, array)}
        </li>
      ))}
    </ul>
  )
}
